// extracted by mini-css-extract-plugin
export default {"root":"ReviewDrawerFooter_root__JYTOM","score":"ReviewDrawerFooter_score__E4hfH","button":"ReviewDrawerFooter_button__0116j","next":"ReviewDrawerFooter_next__k9nRA"};